import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

let ScrollTriggerInit = gsap.registerPlugin( ScrollTrigger );

if( $( '.ring' ).length ) {
  ScrollTriggerInit;

  const ring = document.querySelectorAll( '.ring' );

  ring.forEach( ( elem ) => {
    ScrollTrigger.create( {
      trigger: elem,
      start: 'top bottom',
      end: 'bottom top',
      onEnter: () => $( elem ).addClass( 'rotate' ),
      onEnterBack: () => $( elem ).addClass( 'rotate' ),
      onLeave: () => $( elem ).removeClass( 'rotate' ),
      onLeaveBack: () => $( elem ).removeClass( 'rotate' ),
    } )
  } )
}